import {connect} from 'react-redux';

import {makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {CollapsedItemStates, computeIsItemExpanded} from '../../../../helpers/expansionTogglingHelpers';
import {CollapsedItemKeyPrefixesEnum} from '../../../../models/api/localPreferencesModel';
import {getFindTeammate} from '../../../../store/data/teammates/lazyTeammatesSelectors';
import {getUserLicenseType} from '../../../../store/data/teammates/teammatesSelectors';
import {ToggleExpandItemHandler} from './context/types';
import {TeammatesWorkspaceEditor} from './teammatesWorkspaceEditor';

interface TeammatesWorkspaceEditorContainerProps {
  /** Hash map of workspace item expansion toggle states. */
  collapsedItems: CollapsedItemStates;
  /** Handler for toggling the expanded/collapsed state of section items. */
  onToggleExpandSection: ToggleExpandItemHandler;
}

/*
 * Constants.
 */

const teammatesWorkspaceExpandedKey = `${CollapsedItemKeyPrefixesEnum.WORKSPACE}teammates`;
const defaultIsTeammatesWorkspaceExpanded = true;

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<TeammatesWorkspaceEditorContainerProps>()(() => ({
  userLicenseType: getUserLicenseType,
  findTeammate: getFindTeammate,
}));

/**
 * This component is adapted from <TeammatesWorkspaceContainer /> but for use in <WorkspacesEditor />.
 * @see TeammatesWorkspaceContainer
 */
export const TeammatesWorkspaceEditorContainer = connect(
  mapStateToProps,
  null,
  (stateProps, dispatchProps, ownProps: TeammatesWorkspaceEditorContainerProps) => {
    const {collapsedItems, onToggleExpandSection} = ownProps;

    const isExpanded = computeIsItemExpanded(
      collapsedItems,
      teammatesWorkspaceExpandedKey,
      defaultIsTeammatesWorkspaceExpanded,
    );
    const onToggleExpand = () =>
      onToggleExpandSection({
        key: teammatesWorkspaceExpandedKey,
        defaultExpandedState: defaultIsTeammatesWorkspaceExpanded,
      });

    return {
      ...stateProps,
      ...ownProps,
      isExpanded,
      onToggleExpand,
    };
  },
)(TeammatesWorkspaceEditor);
